import Card from '@mui/material/Card';
import { styled } from '@mui/material/styles';

export const StyledCard = styled(Card)(({ theme }) => ({
  display: 'flex',
  borderRadius: '16px',
  padding: theme.spacing(2),
  width: '100%',
  '& svg': {
    marginRight: theme.spacing(1.5)
  },
  '& div': {
    alignSelf: 'center'
  }
}));
